// ── Wallets Engine ────────────────────────────────────────────────────────────

import { filterByMonth } from "./transactions";

/**
 * Saldo berjalan (running balance) satu rekening s.d. akhir bulan yang dipilih (inklusif)
 * @returns {number}
 */
export function getWalletRunningBalance(wallet, transactions, month, year) {
  const cutoff = new Date(year, month + 1, 0);
  const relevantTxs = transactions.filter(t => new Date(t.date) <= cutoff);
  const incomeIn    = relevantTxs.filter(t => t.walletId === wallet.id && t.type === "income").reduce((a, t) => a + t.amount, 0);
  const transferIn  = relevantTxs.filter(t => t.toWalletId === wallet.id && t.type === "transfer").reduce((a, t) => a + t.amount, 0);
  const expense     = relevantTxs.filter(t => t.walletId === wallet.id && (t.type === "expense" || t.type === "investasi")).reduce((a, t) => a + t.amount, 0);
  const transferOut = relevantTxs.filter(t => t.walletId === wallet.id && t.type === "transfer").reduce((a, t) => a + t.amount, 0);
  return (wallet.initialBalance || 0) + incomeIn + transferIn - expense - transferOut;
}

/**
 * Arus kas satu rekening untuk satu bulan
 * @returns {{ budget, usages, balance }}
 */
export function getWalletMonth(wallet, transactions, month, year) {
  const txs = filterByMonth(transactions, month, year);
  const incomeIn    = txs.filter(t => t.walletId === wallet.id && t.type === "income").reduce((a, t) => a + t.amount, 0);
  const transferIn  = txs.filter(t => t.toWalletId === wallet.id && t.type === "transfer").reduce((a, t) => a + t.amount, 0);
  const expense     = txs.filter(t => t.walletId === wallet.id && (t.type === "expense" || t.type === "investasi")).reduce((a, t) => a + t.amount, 0);
  const transferOut = txs.filter(t => t.walletId === wallet.id && t.type === "transfer").reduce((a, t) => a + t.amount, 0);
  return {
    budget:  incomeIn + transferIn,
    usages:  expense + transferOut,
    balance: getWalletRunningBalance(wallet, transactions, month, year),
  };
}

/**
 * Summary semua rekening untuk satu bulan
 * @returns {Array<wallet & { budget, usages, balance }>}
 */
export function getAllWalletsMonth(wallets, transactions, month, year) {
  return wallets.map(w => ({ ...w, ...getWalletMonth(w, transactions, month, year) }));
}

/**
 * Total pemasukan & pengeluaran aktual bulan ini (exclude transfers — no double counting)
 * @returns {{ actualIncome, actualExpense, actualSisa }}
 */
export function getMonthActuals(transactions, month, year) {
  const txs          = filterByMonth(transactions, month, year);
  const actualIncome = txs.filter(t => t.type === "income").reduce((a, t) => a + t.amount, 0);
  const actualExpense= txs.filter(t => t.type === "expense" || t.type === "investasi").reduce((a, t) => a + t.amount, 0);
  return { actualIncome, actualExpense, actualSisa: actualIncome - actualExpense };
}

/**
 * Berapa yang perlu ditransfer ke tiap rekening (anggaran - saldo saat ini)
 * @returns {Array<{ wallet, totalBudget, perluTransfer, saldoIni, pctCovered, cats }>}
 */
export function getTransferNeeded(byWallet, wallets, transactions, month, year) {
  return byWallet.map(g => {
    const { balance: saldoIni } = getWalletMonth(g.wallet, transactions, month, year);
    const perluTransfer = Math.max(0, g.totalBudget - saldoIni);
    const pctCovered    = g.totalBudget > 0 ? Math.min(saldoIni / g.totalBudget, 1) : 0;
    return { ...g, saldoIni, perluTransfer, pctCovered, sudahCukup: saldoIni >= g.totalBudget };
  });
}
